import styled, { css } from "styled-components";
import { Button } from "antd";
import { theme } from "../../../config";
import { ButtonParams, ButtonWithIconParams } from "./types";

const primaryButton = css`
  background: ${theme.colors.primary};
  color: ${theme.colors.primaryText};
  border: 1.5px solid ${theme.colors.primary};

  &:disabled {
    background: ${theme.colors.neutral.black5};
    color: ${theme.colors.primaryText};
    &:hover {
      background: ${theme.colors.neutral.black5};
      color: ${theme.colors.primaryText};
    }
  }

  &:hover {
    border: 1.5px solid ${theme.colors.primary3};
    background: ${theme.colors.primary3};
    color: ${theme.colors.primaryText};
  }

  &:focus {
    border: 1.5px solid ${theme.colors.primaryDark};
    background: ${theme.colors.primaryDark};
    color: ${theme.colors.primaryText};
  }


`;

const defaultButton = css`
  border: 1.5px solid ${theme.colors.secondary};
  color: ${theme.colors.secondary};

  &:hover {
    border: 1.5px solid ${theme.colors.secondary2};
    color: ${theme.colors.secondary2};
  }

  &:focus {
    color: ${theme.colors.secondary};
    border: 1.5px solid ${theme.colors.secondary};
  }

  &:disabled {
    background: ${theme.colors.white};
    color: ${theme.colors.neutral.black4};
    border: 1.5px solid ${theme.colors.neutral.black4};
    &:hover {
      background: ${theme.colors.white};
      color: ${theme.colors.neutral.black4};
      border: 1.5px solid ${theme.colors.neutral.black4};
    }
  }
`;

export const ButtonStyled = styled(Button)`
  padding: 0 40px;
  border-radius: 4px;
  ${(props: ButtonParams) =>
    props.size === "small"
      ? "height: 32px; font-size: 14px"
      : "height: 40px; font-size: 16px"};

  ${(props: ButtonParams) =>
    props.type === "primary" ? primaryButton : defaultButton};

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 32px;
    font-size: 14px;
  }
`;

const DefaultBorder = css`
  border: 1.5px solid ${theme.colors.secondary};
  &:hover {
    border: 1.5px solid ${theme.colors.secondary1};
  }
  &:focus {
    border: 1.5px solid ${theme.colors.secondary};
  }
  &:disabled {
    color: ${theme.colors.neutral.black4};
    border: 1.5px solid ${theme.colors.neutral.black4};
  }
`;

const DashedBorder = css`
  border: 1.5px dashed ${theme.colors.secondary};
  &:hover {
    border: 1.5px dashed ${theme.colors.secondary1};
  }
  &:focus {
    border: 1.5px dashed ${theme.colors.secondary};
  }
  &:disabled {
    color: ${theme.colors.neutral.black4};
    border: 1.5px dashed ${theme.colors.neutral.black4};
  }
`;

export const DownloadButtonStyled = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px
    ${(props: ButtonWithIconParams) => props.type === "default" && "dashed"}
    ${theme.colors.secondary};
  color: ${(props: ButtonWithIconParams) => props.$isPrimary ? theme.colors.white : theme.colors.secondary};
  border-radius: 4px;
  padding: 0 20px;
  height: 35px;
  ${(props: ButtonWithIconParams) =>
    props.$isPrimary
      ? `background: ${theme.colors.secondary}`
      : ''};

  &:hover {
    color: ${theme.colors.secondary1};
  }

  &:focus {
    color: ${theme.colors.secondary};
  }

  &:disabled {
    color: ${theme.colors.neutral.black4};
  }

  ${(props: ButtonWithIconParams) =>
    props.type === "default" ? DefaultBorder : DashedBorder};

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 32px;
    font-size: 14px;
    padding: 0 15px;
  }
`;
